import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { Invoice } from "@common/types/invoice";
import { FinancialAccount } from "@common/types/financialAccount";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { InvoiceAccountContent } from "../../InvoiceAccountContent";

export const AccountCell = memo(
    ({
        row,
    }: CellContext<
        ViewTableFeatures,
        Invoice,
        FinancialAccount | undefined
    >) => (
        <ViewTableCell>
            <InvoiceAccountContent invoice={row.original} />
        </ViewTableCell>
    ),
);
